import { Component, HostListener, Inject, signal } from '@angular/core';
import { MembershipServiceInterface, ModalHelperService, ModalManagerService } from 'common';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  displayMask = signal(false);
  webPage = true;

  constructor(private modalHelperService: ModalHelperService,
              @Inject('MembershipService') private membershipService: MembershipServiceInterface,
              private modalManagerService: ModalManagerService,
  ) {
    if (window.location.href.indexOf('/certificate-code') >= 0) {
      this.webPage = false;
    }
    this.modalHelperService.listenDisplayMask()
      .subscribe((display: boolean) => {
        this.displayMask.set(display);
      });
    // url action interceptor
    const urlSearchParams = new URLSearchParams(window.location.search);
    const action = urlSearchParams.get('action');
    if (action) {
      if (action === 'mI') {
        const token = urlSearchParams.get('t');
        const invitationId = urlSearchParams.get('id');
        this.membershipService.storeInvitationData(token, invitationId);
      }
    }
  }


  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: any) {
    if (event.key === 'Escape') {
      this.modalManagerService.closeLastModalWithEscape();
    }
  }
}
